var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticStyle: {
        "margin-left": "52%",
        overflow: "inherit",
        "overflow-y": "scroll",
      },
      attrs: { visible: _vm.dialogVisible, width: "98%" },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "title" },
        _vm._l(_vm.switchBtn, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "btns",
              class:
                item.exportType === _vm.selectRow.exportType ? "active" : "",
              on: {
                click: function ($event) {
                  return _vm.handlerSwitchClick(item)
                },
              },
            },
            [_vm._v(" " + _vm._s(item.name) + " ")]
          )
        }),
        0
      ),
      _c(
        "div",
        {
          staticClass: "container2",
          staticStyle: {
            "background-color": "rgba(232,232,232,0.3)",
            padding: "10px",
          },
        },
        [
          _c("p", { staticClass: "p1" }, [
            _vm._v(
              "请维护您在方案后会带出的共性内容 (前端word导出后，及小程序导出前可修改)"
            ),
          ]),
          _c(
            "p",
            { staticClass: "p2" },
            [
              _vm._v(" 报价说明版本: "),
              _c("span", { staticClass: "span1" }, [
                _vm._v("（点击名称查看展示效果)"),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "p3",
                  attrs: { size: "mini" },
                  on: { click: _vm.handlerAddScheme },
                },
                [_vm._v("新增说明版本")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "priceSm" },
            _vm._l(_vm.schemeList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "priceSmText" },
                [
                  _c(
                    "p",
                    {
                      staticClass: "p4",
                      class:
                        _vm.selectedScheme && _vm.selectedScheme.id === item.id
                          ? "active2"
                          : "",
                      on: {
                        click: function ($event) {
                          return _vm.handlerSelectedScheme(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.schemeName))]
                  ),
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { iconClass: "edit" },
                    on: {
                      click: function ($event) {
                        return _vm.handlerSchemeEdit(item)
                      },
                    },
                  }),
                  _c(
                    "el-popconfirm",
                    {
                      attrs: {
                        title:
                          "删除该方案内容,对于方案的合同内也会连带删除,您确认要进行此操作吗？",
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.handlerSchemeDelete(item)
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        staticClass: "svg",
                        attrs: { slot: "reference", iconClass: "delete" },
                        slot: "reference",
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "box-card" },
            _vm._l(_vm.btnList, function (item, keys) {
              return _c(
                "div",
                { key: keys, staticClass: "line1" },
                [
                  _c("div", { staticClass: "left" }, [
                    _c(
                      "p",
                      { staticClass: "p5", staticStyle: { width: "1.5rem" } },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    item.flag
                      ? _c(
                          "div",
                          {
                            staticClass: "btns",
                            on: {
                              click: function ($event) {
                                return _vm.handlerAddBtnClick(keys, item)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  "margin-right": "0.05rem",
                                },
                              },
                              [_vm._v("+")]
                            ),
                            _c("span", [_vm._v("加项")]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "draggable",
                    {
                      staticClass: "right",
                      staticStyle: {
                        "background-color": "white",
                        padding: "10px",
                        "border-radius": "10px",
                      },
                      attrs: { animation: "300", group: "draggableTitle" },
                      on: {
                        start: function ($event) {
                          return _vm.onStart($event, keys)
                        },
                        end: function ($event) {
                          return _vm.onEnd($event, keys)
                        },
                      },
                      model: {
                        value: item.arr,
                        callback: function ($$v) {
                          _vm.$set(item, "arr", $$v)
                        },
                        expression: "item.arr",
                      },
                    },
                    _vm._l(item.arr, function (item1, index1) {
                      return _c(
                        "div",
                        { key: index1, staticClass: "draggableTitle" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btns draggableTitle",
                              class:
                                _vm.selectedTitle.budgetTitle ===
                                  item1.budgetTitle &&
                                _vm.selectedTitle.budgetDescType ===
                                  Number(keys)
                                  ? "active1"
                                  : "",
                              on: {
                                click: function ($event) {
                                  return _vm.handlerSelectBtnClick(item1)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(item1.budgetTitle) + " "),
                              _c("i", {
                                staticClass: "el-icon-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.delByDesc(item1.id)
                                  },
                                },
                              }),
                              item1.budgetTitleContent.length > 0
                                ? _c("img", {
                                    staticClass: "checkIcon",
                                    attrs: {
                                      src: require("@/assets/png/btnRight.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "margin-top": "20px",
              },
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "400px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.combinationSchemeDescription },
                },
                [_vm._v("我已生成好选项，开始组合方案说明")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-left": "500px" },
          attrs: {
            visible: _vm.schemeVisible,
            width: "30%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.schemeVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { "label-position": "top" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "请填写方案说明名称？" },
                model: {
                  value: _vm.selectSchemeRow.schemeName,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectSchemeRow, "schemeName", $$v)
                  },
                  expression: "selectSchemeRow.schemeName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addScheme } },
                [_vm._v("提交")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.schemeVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-left": "500px" },
          attrs: {
            visible: _vm.schemeTitleVisible,
            width: "30%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.schemeTitleVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { "label-position": "top" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "请填写方案说明标题名称？" },
                model: {
                  value: _vm.selectTitleRow.budgetTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectTitleRow, "budgetTitle", $$v)
                  },
                  expression: "selectTitleRow.budgetTitle",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addSchemeTitle },
                },
                [_vm._v("提交")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.schemeTitleVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("offerDetailPopup", {
        ref: "offerDetailPopupBtn",
        attrs: { readonly: false },
        on: { emitSave: _vm.emitSave },
      }),
      _c("offerDetailPopup", {
        ref: "offerDetailPopupCombination",
        attrs: { "show-button": false },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }